<div class="row pad-top-20">
  @if (futurePayments$ | async; as payments) {
    <div class="row column twelve lg-push-two md-eight md-push-two">
      <h1
        dsContent
        class="font-weight-bold"
        [contentPath]="'policy.premiumBilling.futurePaymentPageHeading'"
      ></h1>
      @if (payments?.length === 1) {
        <p
          dsContent
          class="pad-top-20"
          [contentPath]="'policy.premiumBilling.futurePaymentPageBody.term'"
        ></p>
      }
      @if (payments?.length > 1) {
        <p
          dsContent
          class="pad-top-20"
          [contentPath]="'policy.premiumBilling.futurePaymentPageBody.monthly'"
        ></p>
      }
    </div>
    <amfam-payment-schedule
      [payments]="futurePayments$ | async"
      [feature]="vehicleFeatures.ADD_VEHICLE"
    >
    </amfam-payment-schedule>
  }
  <div class="row column twelve lg-push-two md-eight md-push-two">
    <p
      dsContent
      class="font-size-0-75"
      [contentPath]="'policy.premiumBilling.futurePaymentsDisclaimer'"
    ></p>
  </div>
  <div class="pad-top-20 row column twelve lg-push-two md-eight md-push-two">
    <hr aria-hidden="true" class="fill" />
    <call-to-action
      [displayBackButton]="true"
      tertiaryButtonName="Cancel"
      primaryButtonName="Continue"
      (primaryEvent)="nextStep()"
      [secondaryButtonName]="(isPartner$ | async) ? 'Send to an advisor' : 'send to my agent'"
      (secondaryEvent)="notifyAgentEvent.emit({ isProcessExited: true })"
      (tertiaryEvent)="cancelEvent.emit(true)"
      (backEvent)="goBackOneStep()"
    ></call-to-action>
  </div>
</div>
